import { useMutation, useQuery } from 'react-query';
import {
  DropboxSignTemplates,
  HelloSignSignedDocument,
  getSignedDocument,
  overrideSignedDocument,
  saveHelloSignDocument,
} from 'services/dropboxSign';

export const useSignedDocument = ({
  businessId,
  template,
}: {
  businessId?: string;
  template?: DropboxSignTemplates;
}) => {
  const { data: signedDocuments, ...rest } = useQuery<
    HelloSignSignedDocument[]
  >(
    ['dropboxSignedDocuments', businessId, template],
    () => getSignedDocument(template, businessId),
    {
      enabled: !!businessId && !!template,
    },
  );
  return {
    signedDocuments: signedDocuments || [],
    ...rest,
  };
};

export const useSaveHelloSignDocument = (queryProps?: any) => {
  const { mutate, mutateAsync, ...rest } = useMutation(
    (params: {
      businessId: string;
      signatureRequestId: string;
      templateName: DropboxSignTemplates;
    }) =>
      saveHelloSignDocument(
        params.businessId,
        params.signatureRequestId,
        params.templateName,
      ),
    queryProps,
  );
  return {
    saveHelloSignDocument: mutate,
    saveHelloSignDocumentAsync: mutateAsync,
    ...rest,
  };
};

export const useOverrideSignedDocument = (queryProps?: any) => {
  const { mutate, mutateAsync, ...rest } = useMutation(
    (params: {
      businessId: string;
      documentId: string;
      templateName: DropboxSignTemplates;
    }) =>
      overrideSignedDocument(
        params.businessId,
        params.documentId,
        params.templateName,
      ),
    queryProps,
  );
  return {
    overrideSignedDocument: mutate,
    overrideSignedDocumentAsync: mutateAsync,
    ...rest,
  };
};
